import React, { useState } from "react";
import { Box, Button, Typography, Paper, Popover } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Link, useNavigate, useParams } from "react-router-dom";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import AddIcon from "@mui/icons-material/Add";
import editIcon from "./Edit-pen.svg";
import bin from "./bin.svg";
import { useGetSingleServiceQuery } from "../../../../api/financeApi";
import { FormatCurrency } from "../../../../../utils/functions/FormatCurrency";
import {
  FormatStatusA,
  getColorByStatusA,
} from "../../../../../utils/functions/FormatStatus";
const ServiceDetailsView = () => {
  const params = useParams();
  const paramId = Number(params?.id);
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);
  const { data, isLoading } = useGetSingleServiceQuery(paramId);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
  // Dummy data
  const service = {
    serviceName: "Fleets",
    total: 40,
    available: 36,
    unavailable: 4,
    price: "45,000",
    date: "14 Dec 2022",
    status: "Active",
  };

  return (
    <Box className="p-[20px]">
      <Button
        startIcon={<ArrowBackIcon />}
        onClick={() => navigate(-1)}
        sx={{ color: "#305F32", mb: 2 }}
        variant="outlined"
      >
        Back
      </Button>
      <Paper elevation={3} sx={{ padding: 4, borderRadius: 2 }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 4,
          }}
        >
          <Typography variant="h5">Service Details</Typography>
          {/* <Button onClick={handleClick} variant="contained" color="primary">
            Action <KeyboardArrowDownIcon className="text-[#fff]" />
          </Button> */}
        </Box>
        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "center",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "center",
          }}
        >
          <div className="p-3 flex flex-col gap-8 h-[150px] w-[285px]">
            <div className="flex gap-3 items-center">
              <AddIcon className="w-[14px] h-[14px]" />
              <Link
                to={`/dashboard/finance/${URL.AddFacilities}`}
                className="text-[#4B664C] hover:text-[#305F32]"
              >
                Add Facilities & Components
              </Link>
            </div>
            <div className="flex gap-3 items-center">
              <img
                className="w-[14px] h-[14px]"
                src={editIcon}
                alt="edit con"
              />
              <Link
                to={`/dashboard/finance/${paramId}`}
                className="text-[#4B664C] hover:text-[#305F32]"
              >
                Update
              </Link>
            </div>
            <div className="flex gap-3 items-center">
              <img className="w-[14px] h-[14px]" src={bin} alt="delete icon" />
              <button>Delete</button>
            </div>
          </div>
        </Popover>
        <Box
          sx={{
            mb: 4,
            backgroundColor: "#F2F8F2",
            padding: 2,
            borderRadius: 2,
          }}
        >
          <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 600 }}>
            Process Information
          </Typography>
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Box>
              <Typography variant="body2" color="text.secondary">
                Process Type:
              </Typography>
              <Typography variant="body1">
                {data?.result?.serviceName}
              </Typography>
            </Box>
            <Box>
              <Typography variant="body2" color="text.secondary">
                Date Created:
              </Typography>
              <Typography variant="body1">
                {data?.result?.createdDate}
              </Typography>
            </Box>
          </Box>
        </Box>

        <Box sx={{ backgroundColor: "#F2F8F2", padding: 2, borderRadius: 2 }}>
          <Typography variant="subtitle1" sx={{ mb: 1, fontWeight: 600 }}>
            Basic Information
          </Typography>
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: "repeat(3, 1fr)",
              gap: 2,
            }}
          >
            <Box>
              <Typography variant="body2" color="text.secondary">
                Service Name:
              </Typography>
              <Typography variant="body1">
                {data?.result?.serviceName}
              </Typography>
            </Box>
            <Box>
              <Typography variant="body2" color="text.secondary">
                Total:
              </Typography>
              <Typography variant="body1">{data?.result?.total}</Typography>
            </Box>
            <Box>
              <Typography variant="body2" color="text.secondary">
                Total Available:
              </Typography>
              <Typography variant="body1">
                {data?.result?.totalAvailable}
              </Typography>
            </Box>
            <Box>
              <Typography variant="body2" color="text.secondary">
                Total Unavailable:
              </Typography>
              <Typography variant="body1">
                {data?.result?.totalUnavailable}
              </Typography>
            </Box>
            <Box>
              <Typography variant="body2" color="text.secondary">
                Price Per Unit:
              </Typography>
              <Typography variant="body1">
                {FormatCurrency(data?.result?.pricePerUnit)}
              </Typography>
            </Box>
            <Box>
              <Typography variant="body2" color="text.secondary">
                Status:
              </Typography>
              <Typography variant="body2" color="text.secondary">
                <span
                  variant="body1"
                  style={{
                    color: getColorByStatusA(data?.result?.status).color,
                    backgroundColor: getColorByStatusA(data?.result?.status)
                      .backgroundColor,
                    padding: "4px",
                    borderRadius: "4px",
                    marginTop: "4px",
                  }}
                >
                  {FormatStatusA(data?.result?.status)}
                </span>
              </Typography>
            </Box>
          </Box>
        </Box>
      </Paper>
    </Box>
  );
};

export default ServiceDetailsView;
